export type GalleryCategory =
  | "Characters"
  | "Gaming"
  | "Words & Names"
  | "Abstract"
  | "Logos"
  | "Car & Auto"
  | "Desk & Accessories";

export interface GalleryItem {
  id: string;
  title: string;
  direction: string;
  category: GalleryCategory;
  img: string;
  alt: string;
  badge: "concept" | "reference";
}

const S = "https://static.prod-images.emergentagent.com/jobs/c9d62ee0-78ef-4564-9dad-43220be7457a/images/";

export const GALLERY: GalleryItem[] = [
  {
    id: "spark-critter",
    title: "Sparky the Bolt Critter",
    direction: "Pikachu-inspired character",
    category: "Characters",
    img: S + "faa1142afad089aa790de449d86b5115d67c441bf525cb29161aced0788b2eb1.jpeg",
    alt: "Tufted rug of a chubby yellow electric-mouse character with black-tipped ears and a lightning-bolt tail",
    badge: "concept",
  },
  {
    id: "capture-sphere",
    title: "Capture Sphere",
    direction: "Poké Ball-inspired round rug",
    category: "Characters",
    img: S + "c65024210955328d18fb822c08f38d700bc51ae8995eed47fb45f1b83f14ecdf.jpeg",
    alt: "Round tufted rug in red and cream with a black band and white centre button, like a capture ball",
    badge: "concept",
  },
  {
    id: "ember-fox",
    title: "Ember the Fire Fox",
    direction: "Pokémon-inspired character",
    category: "Characters",
    img: S + "d499023e08c6d96ebf3f34b7c788b4cb3f5feac5e4e36cd5b75bbae2b59b247e.jpeg",
    alt: "Tufted rug of an orange fox creature with a flame-shaped cream and red tail",
    badge: "concept",
  },
  {
    id: "web-mask",
    title: "Web-Slinger Mask",
    direction: "Spider-Man-inspired mask",
    category: "Characters",
    img: S + "bfa3f082e7126fbdab0f3215569aa73874f1f756a7957aa1705366181edb4d4b.jpeg",
    alt: "Red tufted rug shaped like a masked hero face with black web lines and white eyes",
    badge: "concept",
  },
  {
    id: "midnight-web",
    title: "Midnight Web",
    direction: "Spider-web design",
    category: "Characters",
    img: S + "e2a10902ff9562697c96cbc9e9981854ac0c487cea7bab3d6ad3a15b80427917.jpeg",
    alt: "Charcoal tufted rug with an ivory spider web radiating across one corner",
    badge: "concept",
  },
  {
    id: "armor-helmet",
    title: "Armored Hero Helmet",
    direction: "Iron Man-inspired design",
    category: "Characters",
    img: S + "df421cab3ea61345e232d6b37985dd033df48f5552f098cb8c17ceab0849967d.jpeg",
    alt: "Tufted rug shaped like a gold and red armored robot helmet with narrow eye slits",
    badge: "concept",
  },
  {
    id: "comic-pow",
    title: "Action Burst",
    direction: "Marvel comic-inspired burst",
    category: "Characters",
    img: S + "a757594e5dfa4641403bc4b51b06c6fa76108abd602d4f4479e25cb6706a2340.jpeg",
    alt: "Tufted rug shaped like a retro comic explosion with the word ZAP in ivory lettering",
    badge: "concept",
  },
  {
    id: "retro-controller",
    title: "Retro Controller",
    direction: "Classic gamepad rug",
    category: "Gaming",
    img: S + "e8e3cd8c7a9762ee8eeb86e81fd95129a54b7bedaa5cf0e1196a8a5b26e04c1a.jpeg",
    alt: "Grey tufted rug shaped like a retro game controller with a d-pad and colourful buttons",
    badge: "concept",
  },
  {
    id: "pixel-hearts",
    title: "Pixel Garden",
    direction: "Pixel-art gaming rug",
    category: "Gaming",
    img: S + "e923eec34ca35500e8e37b9810a07f3847185e2fa96f3991dd2c48c5a2b90d15.jpeg",
    alt: "Rectangular tufted rug with 8-bit pixel hearts, mushrooms and stars in muted colours",
    badge: "concept",
  },
  {
    id: "adventure-awaits",
    title: "Adventure Awaits",
    direction: "Open-world gaming typography",
    category: "Gaming",
    img: S + "e5bd714ddea0ecac875a2af9cfd409287252d762414e23ba188bb28773364a97.jpeg",
    alt: "Forest green tufted rug reading ADVENTURE AWAITS with a gold compass rose",
    badge: "concept",
  },
  {
    id: "insert-coin",
    title: "Insert Coin",
    direction: "Arcade-inspired rug",
    category: "Gaming",
    img: S + "df2e0ebe0d91e253bbe304c0df580265f05f7a9fd1fc728fd0d271f6fac7d8eb.jpeg",
    alt: "Charcoal tufted rug reading INSERT COIN with a red joystick and gold buttons",
    badge: "concept",
  },
  {
    id: "player-1",
    title: "Player 1",
    direction: "Word rug for gamers",
    category: "Gaming",
    img: S + "244a6838e26e9e4b72bbfca3fa4e52f12762bdc026da791125c1ab4bee4779d1.jpeg",
    alt: "Ivory tufted rug reading PLAYER 1 in burgundy pixel lettering with a small heart",
    badge: "concept",
  },
  {
    id: "good-vibes",
    title: "Good Vibes",
    direction: "Word rug with retro lettering",
    category: "Words & Names",
    img: S + "00afb391669c7bcfa8e12a425ba46864709edd6532f3476dda70856f727db207.jpeg",
    alt: "Tufted rug reading GOOD VIBES in groovy retro lettering with a smiling sun",
    badge: "concept",
  },
  {
    id: "alex",
    title: "Alex",
    direction: "Personalised name rug",
    category: "Words & Names",
    img: S + "6add4df27ebe6b19f3235f0425245d4ab9301e67898c7f5c6f0026442c6a885d.jpeg",
    alt: "Forest green tufted rug with the name ALEX in ivory letters surrounded by gold stars",
    badge: "concept",
  },
  {
    id: "home",
    title: "Home",
    direction: "Typography rug",
    category: "Words & Names",
    img: S + "993ed5d999ce33258c55a0f366aea597b2ea8e9c4bfc358bb330f0ee971f7cc9.jpeg",
    alt: "Green tufted rug reading HOME in tall ivory serif letters with a gold leaf sprig",
    badge: "concept",
  },
  {
    id: "bloom-flower",
    title: "Bloom",
    direction: "Floral-shaped rug",
    category: "Abstract",
    img: S + "dc994d6bdc135933c04f20c1c3abb7579797193073df4750d461cc581d87748f.jpeg",
    alt: "Flower-shaped tufted rug with eight petals in cream and burgundy around a gold centre",
    badge: "concept",
  },
  {
    id: "riverbend",
    title: "Riverbend",
    direction: "Abstract organic shape",
    category: "Abstract",
    img: S + "282d174e4e91f029bd1660a74b8b15fd1366da3108e3d3b691b2b7689728bd17.jpeg",
    alt: "Organic blob-shaped tufted rug with flowing bands of green, ivory, burgundy and gold",
    badge: "concept",
  },
  {
    id: "starburst-headliner",
    title: "Starburst Headliner",
    direction: "Full tufted car roof",
    category: "Car & Auto",
    img: S + "0f50647ae3c6557bc0babfae0b05b57feeb05b44224fc301d690259667e122e5.jpeg",
    alt: "Car cabin with the entire roof headliner reupholstered in cream, burgundy and gold tufted wool fitted around the roof lights and handles",
    badge: "concept",
  },
  {
    id: "wave-headliner",
    title: "Wave Line Headliner",
    direction: "Tufted headliner close-up",
    category: "Car & Auto",
    img: S + "79abe0cd6d10d700ff2d7067d308de9851d143303e05c49e8bb493b45b797dc6.jpeg",
    alt: "Close-up of a tufted car headliner with cream and forest-green wave lines, carved grooves and varied pile heights",
    badge: "concept",
  },
  {
    id: "checkered-mat",
    title: "Checkered Footwell Mat",
    direction: "Custom car floor mat",
    category: "Car & Auto",
    img: S + "839446756d31ca468c8beefcce0278b647542dab9806861b80b1078490816457.jpeg",
    alt: "Burgundy and cream checkered tufted car floor mat fitted neatly in a footwell beside the pedals",
    badge: "concept",
  },
  {
    id: "race-number-mat",
    title: "Race Day 07",
    direction: "Racing-themed car mat",
    category: "Car & Auto",
    img: S + "f0878a5a00199614360e1eec06e1c0e71f406de84a989b6423de39a3d218de4b.jpeg",
    alt: "Tufted car floor mat with a black and white checkered flag and a gold number 07, fitted around the pedals",
    badge: "concept",
  },
  {
    id: "riya-car-mat",
    title: "Riya",
    direction: "Personalised car mat",
    category: "Car & Auto",
    img: S + "6f1e412615909a449837eba4e6f98efe74a80c11323417d48a4797e73cea481c.jpeg",
    alt: "Personalised tufted car mat with the name RIYA in cream lettering and burgundy hearts on charcoal wool",
    badge: "concept",
  },
  {
    id: "pixel-desk-mat",
    title: "Pixel Play Desk Mat",
    direction: "Tufted gaming desk mat",
    category: "Desk & Accessories",
    img: S + "e2bd2bbcc5f6afbd6f0513bbe36a5d4acb2179e59437386dee9d848c5eda2c74.jpeg",
    alt: "Long forest-green tufted desk mat with pixel-art motifs under a mechanical keyboard with RGB lighting",
    badge: "concept",
  },
  {
    id: "loop-cut-macro",
    title: "Loop & Cut Edge",
    direction: "Desk mat texture close-up",
    category: "Desk & Accessories",
    img: S + "a73c50427b163e4e3f791824f5d21c9e1478866c52a960bda1f7df39834cbf29.jpeg",
    alt: "Macro photo of a tufted desk mat edge showing cream loops beside shaved burgundy cut pile with a carved groove",
    badge: "concept",
  },
  {
    id: "terracotta-desk-mat",
    title: "Terracotta Waves",
    direction: "Abstract tufted desk mat",
    category: "Desk & Accessories",
    img: S + "c5f7e29305988ea4d2f9ea6949059d7c54e34eee49a1e9027b0ed34aa8137885.jpeg",
    alt: "Long tufted desk mat with abstract waves in sage, cream and terracotta on a wooden desk with a mouse",
    badge: "concept",
  },
  {
    id: "arches-wall-piece",
    title: "Arches & Sun",
    direction: "Tufted wall piece",
    category: "Desk & Accessories",
    img: S + "94ede5d1b2997f32a089e39dba77f122b73e828c938822f629a34e496396aaf4.jpeg",
    alt: "Tufted wall hanging with arches and a sun in green, ivory, burgundy and gold above a wooden console table",
    badge: "concept",
  },
  {
    id: "little-clouds-set",
    title: "Little Clouds Set",
    direction: "Mini tufted accessories",
    category: "Desk & Accessories",
    img: S + "374b67b6a35c61f6035edd2fee8122a02b724f73440da456bcdda4c46470895a.jpeg",
    alt: "Small tufted pieces arranged on a desk: a cream cloud, a burgundy and gold round coaster and a heart charm",
    badge: "concept",
  },
  {
    id: "mirror-flower-charm",
    title: "Mirror Flower Charm",
    direction: "Tufted car accessory",
    category: "Desk & Accessories",
    img: S + "7c9228747e89e9a0e97ed939a3e8c7a9348534439f90644b7b6f2a31f8aca6e1.jpeg",
    alt: "Small tufted flower charm in blush and cream hanging from a car rear-view mirror",
    badge: "concept",
  },
  {
    id: "shinobi-footwell-rug",
    title: "Shinobi Footwell Rug",
    direction: "Anime-ninja-inspired car rug",
    category: "Car & Auto",
    img: S + "8c3ad001fd93bc2691f4db58d1086c57191fbd43890f00a1e106c396343f6e0e.jpeg",
    alt: "Tufted car footwell rug with a masked shinobi warrior face in grey and cream yarn on a crimson background",
    badge: "concept",
  },
  {
    id: "ghost-footwell-rug",
    title: "Grinning Ghost Rug",
    direction: "Ghost character car rug",
    category: "Car & Auto",
    img: S + "afe468c78894a12b9196f3de943052ccaf1245102b4a45d4d8303383180b8537.jpeg",
    alt: "Purple tufted car floor mat shaped like a chubby grinning ghost with red eyes, fitted in a footwell",
    badge: "concept",
  },
  {
    id: "midnight-cat-roof-rug",
    title: "Midnight Cat Roof Rug",
    direction: "Night-sky headliner rug",
    category: "Car & Auto",
    img: S + "a55b38073aa611ac8071b04de1836f8f4f12c8d72ac6515d63802023bfa5cd61.jpeg",
    alt: "Tufted car roof rug with a sleeping cat on a golden crescent moon among navy clouds and stars",
    badge: "concept",
  },
  {
    id: "southwest-ceiling-rug",
    title: "Southwest Ceiling Rug",
    direction: "Patterned headliner rug",
    category: "Car & Auto",
    img: S + "27c686b48eb8f2721975135e5caecdfda33366286c52f7a1a8a0dd5ec6eaa4c6.jpeg",
    alt: "Full car headliner tufted as a Southwestern diamond pattern rug in sky blue, terracotta, cream and charcoal",
    badge: "concept",
  },
  {
    id: "tiger-desk-rug",
    title: "Winking Tiger Desk Rug",
    direction: "Tiger-face desk rug",
    category: "Desk & Accessories",
    img: S + "8722c2fb1657ecc3976253a7f446e945552f84398140976a695249522046f9c2.jpeg",
    alt: "Orange tufted desk rug with a winking tiger face sitting under a backlit mechanical keyboard",
    badge: "concept",
  },
];

export const GALLERY_CATEGORIES: Array<"All" | GalleryCategory> = [
  "All",
  "Characters",
  "Gaming",
  "Words & Names",
  "Abstract",
  "Car & Auto",
  "Desk & Accessories",
];

export function imgSrc(url: string, w: number): string {
  if (url.includes("unsplash.com")) return `${url}?q=85&w=${w}&auto=format&fit=crop`;
  if (url.includes("pexels.com")) return `${url}?auto=compress&cs=tinysrgb&w=${w}`;
  return url;
}
